import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassigned: {
		id: 'backlog.header.controls-bar.filter-bar.unassigned',
		defaultMessage: 'Issues without {target}',
		description: 'Label in the filter describing issues without parents.',
	},
	textFilter: {
		id: 'backlog.header.controls-bar.filter-bar.text-filter',
		defaultMessage: 'Search',
		description:
			'The placeholder of the input textbox used to enter text to filter issues by in the backlog view',
	},
	filterPlaceholder: {
		id: 'backlog.header.controls-bar.filter-bar.filter-placeholder',
		defaultMessage: 'Search backlog',
		description: 'The placeholder of the input textbox used to filter issues in the backlog view',
	},
	unassignedIssueTermRefresh: {
		id: 'backlog.header.controls-bar.filter-bar.unassigned-issue-term-refresh',
		defaultMessage: 'Work items without {target}',
		description: 'Label in the filter describing issues without parents.',
	},
});
